(function () {
  if (window.__mtCargado) return;
  window.__mtCargado = true;
  document.documentElement.classList.add('mt-js');

  var observador = null;

  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            observador.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  function initProducto(raiz) {
    var cont = (raiz || document).querySelector('[data-mt-producto]');
    if (!cont || cont.dataset.mtListo) return;
    cont.dataset.mtListo = '1';

    var principal = cont.querySelector('[data-mt-principal]');
    var minis = cont.querySelectorAll('[data-mt-mini]');

    function mostrar(mini) {
      if (!mini || !principal) return;
      principal.src = mini.dataset.grande;
      principal.srcset = '';
      principal.alt = mini.dataset.alt || '';
      minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
    }
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () { mostrar(mini); });
    });

    // cantidad
    var cantidad = cont.querySelector('[data-mt-cantidad]');
    cont.querySelectorAll('[data-mt-paso]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(cantidad.value, 10) || 1) + parseInt(b.dataset.mtPaso, 10));
        cantidad.value = v;
      });
    });

    // variantes
    var datos = cont.querySelector('[data-mt-variantes]');
    if (!datos) return;
    var variantes = [];
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    var inputId = cont.querySelector('input[name="id"]');
    var precio = cont.querySelector('[data-mt-precio]');
    var tachado = cont.querySelector('[data-mt-tachado]');
    var boton = cont.querySelector('[data-mt-comprar]');
    var grupos = cont.querySelectorAll('[data-mt-opcion]');

    function actual() {
      var elegidas = [];
      grupos.forEach(function (g) {
        var c = g.querySelector('input:checked');
        elegidas.push(c ? c.value : null);
      });
      return variantes.find(function (v) {
        return v.options.every(function (o, i) { return o === elegidas[i]; });
      });
    }

    function pintar() {
      var v = actual();
      if (!v) {
        boton.disabled = true;
        boton.textContent = boton.dataset.textoNoDisponible;
        return;
      }
      inputId.value = v.id;
      precio.textContent = v.precio;
      if (tachado) {
        tachado.textContent = v.tachado || '';
        tachado.hidden = !v.tachado;
      }
      boton.disabled = !v.available;
      boton.textContent = v.available ? boton.dataset.texto : boton.dataset.textoAgotado;
      if (v.media) {
        var mini = cont.querySelector('[data-mt-mini][data-media="' + v.media + '"]');
        if (mini) mostrar(mini);
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    grupos.forEach(function (g) { g.addEventListener('change', pintar); });
  }

  function init(raiz) {
    initReveal(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // editor de Shopify: al recargar un bloque, vuelve a activarlo
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
